import { Expose, Type } from 'class-transformer';
import { EventParticipantModel } from '../models/event-participant.model';
import { EventParticipantUserModel } from '../models/event-participant-user.model';

export class EventParticipantWithUserImpl extends EventParticipantModel {
  @Expose({ name: 'user' })
  @Type(() => EventParticipantUserModel)
  user: EventParticipantUserModel;
}
